import PubSub from 'pubsub-js';
export const publishEvent = (event, data) => {
  PubSub.publish(event, data);
};
export default publishEvent;